import {NatGetApartAssocInfoList, SearchCondition, SearchConditionPageInfo} from './NatGetApartAssocInfoList'
import Http from '../../../../network/Http'
import {SortOrder} from '../../../../components/shared/SortOrder';
import {NatGetApartAssocInfo} from './NatGetApartAssocInfo';
import {NatDeleteApartAssocInfo} from './NatDeleteApartAssocInfo'
import {ContentType} from '../../../../network/Constants';
import {NatPostApartAssocInfo, NatPostApartAssocInfoParams} from './NatPostApartAssocInfo';
import {NatPutApartAssocInfo, NatPutApartAssocInfoParams} from './NatPutApartAssocInfo';

export default class NatApartAssocInfoRepo {
    http: Http;

    constructor(http: Http) {
        this.http = http
    }

    // マンション・管理組合情報一覧取得
    async getApartAssocInfoList(searchCondition?: SearchCondition,
                                searchConditionPageInfo?: SearchConditionPageInfo,
                                searchConditionSortInfos?: SortOrder[]): Promise<NatGetApartAssocInfoList> {
        const searchParams: string[] = [];
        if (searchCondition) {
            if (searchCondition.infoCategoryId) {
                searchParams.push(`infoCategoryId=${encodeURIComponent(searchCondition.infoCategoryId)}`);
            }
            if (searchCondition.publishStartDate) {
                searchParams.push(`publishStartDate=${encodeURIComponent(searchCondition.publishStartDate)}`);
            }
            if (searchCondition.publishEndDate) {
                searchParams.push(`publishEndDate=${encodeURIComponent(searchCondition.publishEndDate)}`);
            }
            if (searchCondition.categoryId) {
                searchParams.push(`categoryId=${encodeURIComponent(searchCondition.categoryId)}`);
            }
        }

        if (searchConditionPageInfo) {
            if (searchConditionPageInfo.pageNum) {
                searchParams.push(`pageNum=${encodeURIComponent(searchConditionPageInfo.pageNum)}`);
            }
            searchParams.push(`page=${encodeURIComponent(searchConditionPageInfo.page)}`);
        }

        if (searchConditionSortInfos) {
            searchConditionSortInfos.forEach((sortInfo) => {
                const value: string = encodeURIComponent(`${sortInfo.sortKey}:${sortInfo.sortDirection}`);
                searchParams.push(`sortInfo=${value}`)
            })
        }
        const searchParamsText: string = searchParams.join('&');

        return await this.http.get(`/api/common/apartAssocInfo?${searchParamsText}`);
    }


    // マンション・管理組合情報取得
    async getApartAssocInfo(apartAssocInfoId: string): Promise<NatGetApartAssocInfo> {
        return await this.http.get(`/api/common/apartAssocInfo/${apartAssocInfoId}`);
    }

    // マンション・管理組合情報削除
    async deleteApartAssocInfo(apartAssocInfoId: string): Promise<NatDeleteApartAssocInfo> {
        return await this.http.delete(`/api/admin/apartAssocInfo/${apartAssocInfoId}`)
    }


    // マンション・管理組合情報登録
    async postApartAssocInfo(request: NatPostApartAssocInfoParams): Promise<NatPostApartAssocInfo> {
        return await this.http.post(`/api/admin/apartAssocInfo`, {
                title: request.title,
                infoCategoryId: request.infoCategoryId,
                categoryId: request.categoryId,
                sortOrder: request.sortOrder,
                publishStartDate: request.publishStartDate,
                publishEndDate: request.publishEndDate,
                browseAuthority: request.browseAuthority,
                publishMaterialInfo: request.publishMaterialInfo,
            }, ContentType.JSON,
        )
    }

    async putUpdateApartAssocInfo(request: NatPutApartAssocInfoParams): Promise<NatPutApartAssocInfo> {
        return await this.http.put(`/api/admin/apartAssocInfo`, request)
    }

}
